import { render, staticRenderFns } from "./GlobalPaymentsCreditCard.vue?vue&type=template&id=18534cef"
import script from "./GlobalPaymentsCreditCard.vue?vue&type=script&lang=ts"
export * from "./GlobalPaymentsCreditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports